import naja from 'naja';

function dialog() {
  function resetModalInputs(modal) {
    modal.querySelectorAll('form').forEach((form) => {
      form.reset();

      form.querySelectorAll('.is-invalid, .valid').forEach((el) => {
        el.classList.remove('is-invalid', 'valid');
      });

      form.querySelectorAll('.invalid-feedback').forEach((el) => {
        el.textContent = '';
      });
    });
  }

  function resetModalSnippet(modal) {
    const url = modal.dataset.resetUrl;

    if (!url) {
      return;
    }

    naja.makeRequest('GET', url);
  }

  function closeModal(modal) {
    modal.classList.remove('show-modal');
    resetModalInputs(modal);
    resetModalSnippet(modal);
  }

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      const modals = document.querySelectorAll('.modal.show-modal');
      const modal = modals[modals.length - 1];

      if (!modal) {
        return;
      }

      e.preventDefault();
      closeModal(modal);
    }
  });

  document.addEventListener('click', (e) => {
    const openTrigger = e.target.closest('[data-open-modal]');

    if (openTrigger) {
      e.preventDefault();
      const id = openTrigger.dataset.openModal;
      const modal = document.getElementById(id);

      if (modal) {
        modal.classList.add('show-modal');
      }

      return;
    }

    const closeTrigger = e.target.closest('[data-close-modal]');

    if (closeTrigger) {
      const id = closeTrigger.dataset.closeModal;
      const modal = document.getElementById(id);

      if (modal) {
        closeModal(modal);
      }

      return;
    }

    const modal = e.target.classList.contains('modal') ? e.target : null;

    if (modal) {
      closeModal(modal);
    }
  });
}

dialog();
